import { confirmPopup } from "helpers/common";
import moment from "moment";
import { Button } from "react-bootstrap";
import { Calendar } from 'react-date-range';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { enUS } from 'date-fns/locale';

const WorkBookCalendar = ({ data, handleChange, maxDatePast, maxDateFuture }) => {

  console.log("maxDatePast >>>", maxDatePast);
  console.log("maxDateFuture >>>", maxDateFuture);


  // let activeDate = localStorage.getItem(`calendar_activeDate`);
  let activeDate = data.activeDate;

  const handleChangeCalendarData = (key, value) => {
    handleChange(key, value);
    // localStorage.setItem(`calendar_${key}`, value);
  }

  const handleSelectDate = async (date) => {
    try {
      if(!date) {
        handleChangeCalendarData("activeDate", "");
      }
      let confirmed = await confirmPopup("Your existing planets configuration will be removed.");
      if(confirmed) {
        handleChangeCalendarData("activeDate", date.toISOString());
      }
    } catch(err) {
      console.error("Error in calendar select date", err);
    }
  }
  
  return (
    <>
      {activeDate && (
        <Button
          onClick={() => {
            handleChangeCalendarData("activeDate", "");
          }}
          className="btn btn-sm d-flex gap-10 align-items-center"
          variant="transparent"
          style={{ color: "#265436" }}
        >
          <i className="fa fa-trash-o" aria-hidden="true"></i>
          Clear Selection
        </Button>
      )}
      <Calendar
        className="workbook-calendar"
        date={activeDate && new Date(activeDate)}
        onChange={handleSelectDate}
        minDate={maxDatePast}
        maxDate={maxDateFuture}
        locale={enUS}  // <-- ADD THIS!
      />
    </>
  )
}

export default WorkBookCalendar;